import React, { Fragment } from 'react'
import injectStyles from 'react-jss'

import { withStyles } from '@material-ui/core/styles'
import InputBase from '@material-ui/core/InputBase'
import InputLabel from '@material-ui/core/InputLabel'
import { MenuItem } from '@material-ui/core'
import { Select } from '@material-ui/core'
import { styles } from './styles'
import HardwareKeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down'

const BootstrapInput = withStyles(theme => ({
  input: {
    border: '1px solid #E2E2FC',
    borderRadius: 8,
    padding: '0 9px',
    backgroundColor: '#FFFFFF',
    width: '100%',
    height: 40,

    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginBottom: 24,
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderColor: '#4F5B94',
      borderRadius: 8,
      backgroundColor: '#FFFFFF',
    },
  },
}))(InputBase)

const SelectStyled = ({
  label,
  classes,
  value,
  onChange,
  options,
  placeholder = '',
  MenuProps = {},
  cypress_id,
  description,
  multiple,
  disabled,
}) => {
  return (
    <Fragment>
      {label ? (
        <InputLabel required className={classes.label}>
          {label}
        </InputLabel>
      ) : null}
      <Select
        className={classes.select}
        value={value}
        displayEmpty
        onChange={event => onChange(event.target.value, !event.target.value)}
        input={<BootstrapInput />}
        IconComponent={HardwareKeyboardArrowDown}
        MenuProps={MenuProps}
        renderValue={(selected, props) => {
          if (selected.length === 0) {
            return (
              <span className={classes.selecValue}>
                <em>{placeholder || label}</em>
              </span>
            )
          }

          if (Array.isArray(selected)) {
            return (
              <span className={classes.selecValue}>
                {selected
                  .map(s => options.find(item => item.value == s).name)
                  .join(', ')}
              </span>
            )
          } else {
            return (
              <span className={classes.selecValue}>
                {options.find(item => item.value == selected).name}
              </span>
            )
          }
        }}
        cypress_id={cypress_id}
        multiple={multiple}
        disabled={disabled}
      >
        {options.map(item => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
      {description ? (
        <div className={classes.description}>{description}</div>
      ) : null}
    </Fragment>
  )
}

export default injectStyles(styles)(SelectStyled)
